import React, { Component } from 'react';
import TableText from "@/components/table/TableText";
import { Table, } from 'antd';
import { observer, inject } from "mobx-react";
import { toJS } from 'mobx';

@inject('store')
@observer
class App extends Component {
    onChange = (name, value, i) => {
        let { roomData, dayData, foodData } = this.props.store.dailyMonth;
        let data = [...toJS(dayData)];
        data[i][name] = value;
        this.props.store.dailyMonth.onChange({
            roomData, foodData, dayData: data
        });
    }
    render() {
        const { dayData, loading } = this.props.store.dailyMonth;
        const columns = [
            {
                title: <span>Other Revenue <br /> 其他收入</span>,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    const props = { text: "Total Other Revenue <br/> 其他收入总计", index, type: 'text', name: "name", };

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Today <br /> 今日实际</span>,
                dataIndex: 'other_day',
                key: 'other_day',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "other_day", onChange: this.onChange,
                        compared: {
                            title: ['Today <br /> 今日实际'],
                            record,
                            sqlName: "m_daily_total"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Last Year <br /> 去年当日</span>,
                dataIndex: 'other_last',
                key: 'other_last',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "other_last", onChange: this.onChange,
                        compared: {
                            title: ['Last Year <br /> 去年当日'],
                            record,
                            sqlName: "m_daily_total"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }
        ]
        const columnsRev = [
            {
                title: <span>Daily Revenue<br /> 每日总收入</span>,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    const props = {
                        text: "Grand Total<br/>总计", index, type: 'text', name: "name",

                    };

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Today <br /> 今日实际</span>,
                dataIndex: 'rev_day',
                key: 'rev_day',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "rev_day",
                        compared: {
                            title: ['Today <br /> 今日实际'],
                            record,
                            sqlName: "m_daily_total"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Last Year <br /> 去年当日</span>,
                dataIndex: 'rev_last',
                key: 'rev_last',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "rev_last",
                        compared: {
                            title: ['Last Year <br /> 去年当日'],
                            record,
                            sqlName: "m_daily_total"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }
        ]

        return (
            <div className="total-table">
                <Table
                    columns={columns}
                    dataSource={toJS(dayData)}
                    size="middle"
                    bordered
                    pagination={false}
                    loading={loading}
                    className="content"
                    rowKey={(record, index) => index}
                />
                <Table
                    columns={columnsRev}
                    dataSource={toJS(dayData)}
                    size="middle"
                    bordered
                    pagination={false}
                    loading={loading}
                    className="content"
                    rowKey={(record, index) => index}
                />

            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/Total/index.js